import { useState } from 'react'
import { Button, Group, SegmentedControl, Table, Text, TextInput } from '@mantine/core'
import backend from '../../backend/backend'
import PageHeader from '../../components/shared/PageHeader'
import { useResource, useT } from '../../hooks'
import Message from '../../i18n/Message'
import { keys, loadReport } from '../../store/dataActionCreators'
import { naira } from '../../utils/format'

const NAMES = ['summary', 'collections', 'aging', 'agents', 'defaults']
const isMoney = (k) => /kobo$/i.test(k)

export default function Reports() {
  const t = useT()
  const [name, setName] = useState('summary')
  const [range, setRange] = useState({ from: '', to: '' })
  const params = { from: range.from || undefined, to: range.to || undefined }
  const { data, loading } = useResource(keys.report(name, params), () => loadReport(name, params))
  const rows = data?.rows || []
  const columns = rows[0] ? Object.keys(rows[0]) : []
  return (
    <>
      <PageHeader title="reports_title" actions={<Button component="a" href={backend.reportCsvUrl(name, params)} variant="default"><Message id="export_csv" /></Button>} />
      <SegmentedControl mb="md" value={name} onChange={setName} style={{ maxWidth: '100%', overflowX: 'auto' }}
        data={NAMES.map((n) => ({ value: n, label: t(`report_${n}`) }))} />
      <Group mb="md" align="flex-end">
        <TextInput type="date" label={t('filter_from')} value={range.from} onChange={(e) => setRange({ ...range, from: e.currentTarget.value })} />
        <TextInput type="date" label={t('filter_to')} value={range.to} onChange={(e) => setRange({ ...range, to: e.currentTarget.value })} />
      </Group>
      {rows.length === 0 ? (
        <Text c="dimmed"><Message id={loading ? 'loading' : 'empty_list'} /></Text>
      ) : (
        <Table.ScrollContainer minWidth={520}>
          <Table>
            <Table.Thead>
              <Table.Tr>{columns.map((c) => <Table.Th key={c}><Message id={`rep_${c}`} /></Table.Th>)}</Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {rows.map((r, i) => (
                <Table.Tr key={i}>
                  {columns.map((c) => <Table.Td key={c} className="num">{isMoney(c) ? naira(r[c]) : String(r[c] ?? '—')}</Table.Td>)}
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Table.ScrollContainer>
      )}
    </>
  )
}
